<script lang="ts">
	import { cn } from '$lib/utils/class-merge';
	import type { Snippet } from 'svelte';
	import { fade } from 'svelte/transition';

	type Props = {
		children: Snippet;
		className?: string;
	};

	let { children, className = '' }: Props = $props();
</script>

<div transition:fade={{ delay: 50, duration: 100 }} class="relative z-30">
	<div class="fixed inset-0 bg-gray-200 opacity-95 transition-opacity dark:bg-gray-800"></div>
	<div class="fixed inset-0 z-10 overflow-y-auto">
		<div class="flex min-h-full justify-center p-4 sm:items-center sm:p-0">
			<div class={cn('relative w-full max-w-xl overflow-hidden p-0 md:p-5', className)}>
				{#if children}
					{@render children()}
				{/if}
			</div>
		</div>
	</div>
</div>
